<div class="authorities-available-list tabbing">
  <div class="tabs">
    <button
      type="button"
      pButton
      label="{{ 'Authorities Found (' + authorities.length + ')' }}"
      class="active"
    ></button>
    <button type="button" pButton (click)="showRequestNewBox()" label="New Request" class="p-button-outlined"></button>
  </div>

  <ul class="authority-row">
    <li
      *ngFor="let authority of authorities"
      (click)="!authority.isDisabled && showAuthorities(authority)"
      [class.ui-state-disabled]="authority.isDisabled"
    >
      <authority-card [authority]="authority"></authority-card>
    </li>
  </ul>
</div>
